<template>
    <div class=".container-fluid">
        <NavBar></NavBar>

        <div class="KSpinner" v-if="isLoading">                    
            <div class="spinner-border text-info"></div>
            <h2 class="LoadingText">Loading....</h2>
        </div>

        <div class="row">
            <div class="col d-none d-lg-block bg-theme">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4 bg-theme">

            <div class="alert alert-success alert-dismissible fade show" role="alert" v-for="msg in success" :key="msg" >
                {{msg}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    np<span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-for="msg in errors" :key="msg" >
                {{msg}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="alert alert-info alert-dismissible fade show" role="alert" v-for="msg in info" :key="msg" >
                {{msg}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            
            </div>
            <div class="col d-none d-lg-block bg-theme">
            </div>
        </div>
    </div>
                    
</template>

<script>
import { Auth } from '@/firebase/auth';
import NavBar  from '@/components/NavBar';

export default {
  name: 'logout',
  components: {
      NavBar
  },
  data() {
    return {
        isLoading:true,
        errors: [],
        success: [],
        info: [],
    };
  },
  props:{
  },
  created(){
        Auth.signOut().then(() => {
            Auth.onAuthStateChanged(() => {
                this.isLoading = false;
                if(this.currentRouteName != "Ads"){
                    this.$store.commit('logout');
                    this.$router.push('/login');
                }
                
            });
        });
  },
  methods: {
  },
  computed:{
      currentRouteName() {
        return this.$route.name;
    }
  }
};
</script>

